import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getRegionNo = () =>
  httpClient.get(apis.GET_REGION_NO, {
    ignoreLoading: true,
    ignore: true,
  });
export const checkExistMobile = (mobile) =>
  httpClient.get(apis.CHECK_EXIST_MOBILE + mobile, {
    ignoreLoading: true,
    ignore: true,
  });
export const getMobileCode = (mobile) =>
  httpClient.get(apis.SMS_REGISTER + mobile, {
    ignoreLoading: true,
  });
export const getMobileCodeLogin = (mobile) =>
  httpClient.get(apis.LOGIN_SMS_REGISTER + mobile, {
    ignoreLoading: true,
  });
export const getMobileCodeLoginWithoutMobile = () =>
  httpClient.get(apis.LOGIN_SMS_REGISTER_WITHOUT_MOBILE, {
    ignoreLoading: true,
  });
export const getMobileCodeLoginUniqueGlobal = (mobile) =>
  httpClient.get(apis.LOGIN_SMS_REGISTER_UNIQUE_GLOBAL + mobile, {
    ignoreLoading: true,
  });
export const updateMobile = (payload) => httpClient.post(apis.UPDATE_MOBILE, payload);
